import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import PropTypes from "prop-types";
import Config from "conFig.js";
import { NumericFormat } from "react-number-format";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

const Capnhattuyencodinh = React.memo(function Capnhattuyencodinh(props) {
  const { tuyen_id } = props;
  const [thututoanquoc, setThututoanquoc] = React.useState(0);
  const [tinh_a, setTinh_a] = React.useState([]);
  const [tinh_a_value, setTinh_a_value] = React.useState(null);
  const [tinh_b, setTinh_b] = React.useState([]);
  const [tinh_b_value, setTinh_b_value] = React.useState(null);
  const [matuyen, setMatuyen] = React.useState("");
  const [benxe_a, setBenxe_a] = React.useState("");
  const [benxe_b, setBenxe_b] = React.useState("");
  const [hanhtrinh, setHanhtrinh] = React.useState("");
  const [culytuyen, setCulytuyen] = React.useState(0);
  const [luuluong, setLuuluong] = React.useState(0);
  const [dangkhaithac, setDangkhaithac] = React.useState(0);
  const [luuluongconlai, setLuuluongconlai] = React.useState(0);
  const [thoigiangiancach, setThoigiangiancach] = React.useState(0);
  const [phanloaituyen, setPhanloaituyen] = React.useState("");
  const [nguontuyen, setNguontuyen] = React.useState("");
  const [ghichu, setGhichu] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const gettinhthanh = () => {
    var url = Config.backend + "/api/Diaphuong/gettinh?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTinh_a(data);
        setTinh_b(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gettuyentheoid = () => {
    var url =
      Config.backend +
      "/api/Tuyen/gettuyencodinhid?id=" +
      tuyen_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTinh_a_value({ id: data[0].tinh_a_id, ten: data[0].tinh_a });
        setTinh_b_value({ id: data[0].tinh_b_id, ten: data[0].tinh_b });
        if (data[0].thututoanquoc) setThututoanquoc(data[0].thututoanquoc);
        if (data[0].matuyen) setMatuyen(data[0].matuyen);
        if (data[0].benxe_a) setBenxe_a(data[0].benxe_a);
        if (data[0].benxe_b) setBenxe_b(data[0].benxe_b);
        if (data[0].hanhtrinh) setHanhtrinh(data[0].hanhtrinh);
        if (data[0].culytuyen) setCulytuyen(data[0].culytuyen);
        if (data[0].luuluong) setLuuluong(data[0].luuluong);
        if (data[0].dangkhaithac) setDangkhaithac(data[0].dangkhaithac);
        setLuuluongconlai(data[0].luuluong - data[0].dangkhaithac);
        if (data[0].thoigiangiancach)
          setThoigiangiancach(data[0].thoigiangiancach);
        if (data[0].phanloaituyen) setPhanloaituyen(data[0].phanloaituyen);
        if (data[0].nguontuyen) setNguontuyen(data[0].nguontuyen);
        if (data[0].ghichu) setGhichu(data[0].ghichu);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhattuyen = () => {
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/Phuongtien/capnhaptuyencodinh";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id: tuyen_id,
          thututoanquoc: thututoanquoc,
          matuyen: matuyen,
          tinh_a_id: tinh_a_value.id,
          tinh_b_id: tinh_b_value.id,
          benxe_a_id: null,
          benxe_a: benxe_a,
          benxe_b_id: null,
          benxe_b: benxe_b,
          hanhtrinh: hanhtrinh,
          culytuyen: culytuyen,
          luuluong: luuluong,
          dangkhaithac: dangkhaithac,
          luuluongconlai: luuluongconlai,
          thoigiangiancach: thoigiangiancach,
          phanloaituyen: phanloaituyen,
          nguontuyen: nguontuyen,
          ghichu: ghichu,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateCapnhat = () => {
    // Kiem tra cac truong bat buoc nhap
    if (!tinh_a_value.id || tinh_a_value.id === 0) {
      return Error.ER0002;
    }
    if (!tinh_b_value.id || tinh_b_value.id === 0) {
      return Error.ER0003;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    gettinhthanh();
    gettuyentheoid();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Thứ tự toàn quốc"
                variant="outlined"
                size="small"
                value={thututoanquoc}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setThututoanquoc(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Mã tuyến"
                variant="outlined"
                value={matuyen}
                size="small"
                onChange={(event) => {
                  setMatuyen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={tinh_a_value}
                options={tinh_a}
                getOptionLabel={(option) => option.ten}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, value) => {
                  setTinh_a_value(value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn tỉnh đầu"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "37px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={tinh_b_value}
                options={tinh_b}
                getOptionLabel={(option) => option.ten}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, value) => {
                  setTinh_b_value(value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn tỉnh cuối"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "37px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Bến đầu"
                variant="outlined"
                value={benxe_a}
                size="small"
                onChange={(event) => {
                  setBenxe_a(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Bến cuối"
                variant="outlined"
                value={benxe_b}
                size="small"
                onChange={(event) => {
                  setBenxe_b(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Hành trình"
                variant="outlined"
                value={hanhtrinh}
                size="small"
                onChange={(event) => {
                  setHanhtrinh(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Cự ly tuyến"
                variant="outlined"
                size="small"
                value={culytuyen}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setCulytuyen(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Lưu lượng"
                variant="outlined"
                size="small"
                value={luuluong}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setLuuluong(value);
                  setLuuluongconlai(value - dangkhaithac);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Đang khai thác"
                variant="outlined"
                size="small"
                value={dangkhaithac}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setDangkhaithac(value);
                  setLuuluongconlai(luuluong - value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Lưu lượng còn lại"
                variant="outlined"
                size="small"
                value={luuluongconlai}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setLuuluongconlai(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Thời gian giãn cách"
                variant="outlined"
                size="small"
                value={thoigiangiancach}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setThoigiangiancach(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Phân loại tuyến"
                variant="outlined"
                value={phanloaituyen}
                size="small"
                onChange={(event) => {
                  setPhanloaituyen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Nguồn tuyến"
                variant="outlined"
                value={nguontuyen}
                size="small"
                onChange={(event) => {
                  setNguontuyen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Ghi chú"
                variant="outlined"
                value={ghichu}
                size="small"
                onChange={(event) => {
                  setGhichu(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhattuyen}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhattuyencodinh.propTypes = {
  tuyen_id: PropTypes.number,
};
export default Capnhattuyencodinh;
